import CalibrationPatternTable from '../components/CalibrationPatternTable/CalibrationPatternTable.vue'
import CalibrationPatternTemplateTable from '../components/CalibrationPatternTemplateTable/CalibrationPatternTemplateTable.vue'
import CalibrationCertifiedTable from '../components/CalibrationCetifiedTable/CalibrationCertifiedTable.vue'

export default {
  components: {
    CalibrationPatternTable,
    CalibrationPatternTemplateTable,
    CalibrationCertifiedTable,
  },

  data: () => ({
    tab: null,
    userType: null,
  }),

  methods: {},

  created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType

    switch (this.$route.query.tab) {
      case 'pattern':
        this.tab = 'tabPattern'
        break
      case 'template':
        this.tab = 'tabTemplate'
        break
      default:
        this.tab = null
        break
    }
    this.$router.replace('/calibration')
  },
}
